
export default {
    name: "QdapHomeConsultationSection",
    props: {
    
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            pageData: null,
            img: "~/static/welcome-visual.png",
        }
    },    
    computed: {
      bannerImgDesktop() {
        // return `background-image: url(${require("~/static/welcome-visual.png")});
        return `background-image: url(${this.data?.ImageDesktop?.url});
        background-size: cover;
        background-position: right;
        background-repeat: no-repeat;
        `
      },
    },



    mounted() {
    },
    methods: {
    },
}
